export default class Element {
   #element = null

   constructor(element) {
      this.#element = element
      if (!element) {
         console.error('Element: element = null')
      }
   }

   getElement = () => this.#element

   getParent = () => this.getElement()?.parentElement

   getHeight = () => parseInt(this.getElement()?.offsetHeight)

   getBottomPointRelativeToPage = () => (parseInt(this.getElement()?.offsetTop) + this.getHeight())
}